import moment from 'moment';

const defaultTZ = () => moment().tz() || moment.tz.guess();

const dateToLocalMoment = (date: string) => moment.utc(date).local().tz(defaultTZ());

const dateStringToLocalTime = (date: string): string => dateToLocalMoment(date).format('MMM D, YYYY, h:mm A z');

export default dateStringToLocalTime;
